import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfPeople, ModelOfPeopleForm } from '../../database';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import moment from 'moment';
import { AxiosResponse } from 'axios';

const initialValuesOfUnityPeople = {
	ORGAO: '',
	ORGAOUNIDADE: '',
	CARGO: '',
	NOME: '',
	DATANASCIMENTO: '',
	CPF: '',
};
export const useListUnityPeoplesController = () => {
	const [unityPeoplesData, setUnityPeoplesData] = useState<ModelOfPeople[]>([]);
	const [selectedUnityPeople, setSelectedUnityPeople] = useState<ModelOfPeople>(initialValuesOfUnityPeople);
	const [loading, setLoading] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);

	const { selectedPeopleUnity, userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		CARGO: Yup.string().required('* Campo obrigatório'),
		NOME: Yup.string().required('* Campo obrigatório'),
		DATANASCIMENTO: Yup.string().required('* Campo obrigatório'),
		CPF: Yup.string().required('* Campo obrigatório'),
		ORGAOUNIDADE: Yup.string().required('* Campo obrigatório'),
	});

	const getUnityPeoples = () => {
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post('/unitys/people2', { ORGAOUNIDADE: selectedPeopleUnity.ID, ROW: rows })
			.then((response) => {
				console.log("Lista de Pessoas da Undiade: ",response)
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setUnityPeoplesData(
						unityPeoplesData.concat(
							response.data
						)
					);
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
				setLoadingRows(false);
			});
	};

	useEffect(() => {
		getUnityPeoples();
	}, []);

	const removeUnityPeople = (UnityPeople: ModelOfPeople) => {
		setLoading(true);
		api.delete(`people/${UnityPeople.ID}`)
			.then((response) => {
				const newList = unityPeoplesData.filter((person) => person.ID !== response.data.ID);
				setUnityPeoplesData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A pessoa foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getUnityPeoples();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editUnityPeople = (UnityPeople: ModelOfPeopleForm) => {
		setLoadingEdit(true);

		const editedUnityPeople: ModelOfPeople = {
			ORGAOUNIDADE: UnityPeople.ORGAOUNIDADE,
			CARGO: UnityPeople.CARGO,
			NOME: UnityPeople.NOME,
			CPF: UnityPeople.CPF,
			ORGAO: userAgencyId,
			DATANASCIMENTO: moment(UnityPeople.DATANASCIMENTO, 'DD/MM/YYYY')
				.toDate()
				.toLocaleDateString('en', { year: 'numeric', month: '2-digit', day: '2-digit' }),
		};

		api.post(`people/${selectedUnityPeople?.ID}/${selectedUnityPeople.ID_ORGAOUNIDADEPESSOA}`, editedUnityPeople)
			.then(() => {
				// getUnityPeoples();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A pessoa foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch((err) => {
				getUnityPeoples();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const openDeleteDialog = (UnityPeople: ModelOfPeople) => {
		setDeleteDialog(true);
		setSelectedUnityPeople(UnityPeople);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (UnityPeople: ModelOfPeopleForm) => {
		setEditDialog(true);
		setSelectedUnityPeople(UnityPeople);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfPeopleForm>({
		initialValues: {
			ORGAO: '',
			ORGAOUNIDADE: '',
			CARGO: '',
			NOME: '',
			DATANASCIMENTO: '',
			CPF: '',
		},
		onSubmit: async (values) => await editUnityPeople(values),
		validationSchema,
	});

	return {
		getUnityPeopleListController: {
			formik,
			unityPeoplesData,
			selectedUnityPeople,
			loading,
			loadingRows,
			deleteDialog,
			loadingEdit,
			editDialog,
			toast,
			maxData,
			rows,
		},
		handleUnityPeopleListController: {
			removeUnityPeople,
			editUnityPeople,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			setRows,
		},
	};
};
